import PageComponent from '/root/workspace/JiaMeiHuiBackstage_3hGC/src/pages/login/index';

const PageComponentName = PageComponent;

export default PageComponentName;
